export const LOAN_FEE_DOCUMENT_MAX_BYTES = 10 * 1024 * 1024;
export const LOAN_FEE_DOCUMENT_TYPES = ['application/pdf', 'image/png', 'image/jpeg'];

export function validateLoanFeeDocument(name: string, size: number, mimeType: string): string {
  const extension = name.split('.').pop()?.toLowerCase();
  const type =
    mimeType ||
    ({ pdf: 'application/pdf', png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg' }[extension ?? ''] ?? '');
  if (!LOAN_FEE_DOCUMENT_TYPES.includes(type) || size <= 0 || size > LOAN_FEE_DOCUMENT_MAX_BYTES) {
    throw new Error('invalidDocument');
  }
  return type;
}

export function getLoanFeeDocumentName(url: string): string {
  const name = url.split('/').pop()?.split('?')[0] ?? 'document';
  try {
    return decodeURIComponent(name);
  } catch {
    return name;
  }
}
